import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getCustomersList } from '../../../store/NTX/Peoples/peoplesSlice';
import { useTranslation } from 'react-i18next';

const useGetCustomersList = () => {
  const { i18n, t } = useTranslation();

  const dispatch = useAppDispatch();

  const { CustomersList, loading, error } = useAppSelector(state => state.Peoples);

  useEffect(() => {
    if (CustomersList?.length === 0) {
      dispatch(getCustomersList());
    }
  }, [dispatch]);

  const OptionCustomers = CustomersList?.map(item => ({
    value: item.id,
    label: i18n.language === 'en' ? item.name : item.name2,
    id: item.id,
    parentId: item.parentId
  }));

  //#region TreeData
  const convertToTreeData = () => {
    const map = new Map();
    const treeData: { title: string; value: string; children: never[] }[] = [];

    OptionCustomers?.forEach(item => {
      const node = {
        title: item.label,
        value: item.id,
        children: []
      };

      map.set(item.id, node);

      if (item.parentId === null) {
        treeData.push(node);
      } else {
        const parent = map.get(item.parentId);
        if (parent) {
          parent.children.push(node);
        }
      }
    });

    return treeData;
  };
  const treeCustomerData = convertToTreeData();
  //#endregion

  const OptionCustomersWithAll = [
    {
      label: t('جميع العملاء'),
      value: 'All'
    },
    ...OptionCustomers
  ];

  const CustomersPosCategory = CustomersList?.filter(f => f.peopleCategory === 'POS')?.map(item => ({
    value: item.id,
    label: i18n.language === 'en' ? item.name : item.name2,
    id: item.id,
    parentId: item.parentId
  }));

  return {
    CustomersList,
    OptionCustomersWithAll,
    OptionCustomers,
    treeCustomerData,
    CustomersPosCategory,
    loading,
    error
  };
};

export default useGetCustomersList;
